import React from 'react';
import PropTypes from 'prop-types';

export const addressString = (address, newlines = true) => {
  let addr = address.street;
  if (address.suite) addr += (newlines ? '\n' : ' ') + address.suite;
  addr += newlines ? '\n' : ' ';
  if (address.city) addr += address.city;
  if (address.state) addr += ', ' + address.state;
  if (address.zip) addr += ' ' + address.zip;
  return addr;
};

const AddressLink = ({ address, rawaddress, style, className }) => {
  if (!address && !rawaddress) return null;
  const addr = rawaddress ? rawaddress : addressString(address);
  return (
    <a target='_blank' href={'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(addr)}>
      {addr.split('\n').map((line, index) =>
        <div className={className} style={style} key={index}>
          {line}
        </div>
        )}
    </a>
  );
};

AddressLink.propTypes = {
  address: PropTypes.shape({
    street: PropTypes.string,
    suite: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }),
  rawaddress: PropTypes.string,
};

export default AddressLink;



// WEBPACK FOOTER //
// ./src/components/AddressLink.js